import { useEffect } from 'react';
import AboutPage from '../components/AboutPage';

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <AboutPage />
    </main>
  );
}

export default About;